import { Helmet } from "react-helmet-async";
import {
  Button,
  CustomModal,
  Dropdown,
  InfoCard,
  Input,
  ProfileInfo,
} from "../../components";
import { AgentSignUpController } from "../../controllers";
import { connect } from "react-redux";
import { Cancel, Documentupload, Import, Logout } from "../../../assets";
import { logout } from "../../../core/service";
import moment from "moment-jalaali";

class AgentSignUp extends AgentSignUpController {
  componentDidMount() {
    // this.getDefaultAgent();
    // this.agentUploadList();

    this.getDefaultUpload();
  }

  render() {
    const {
      uploadError,
      step,
      license_code,
      person,
      step1Errors,
      national_id,
      inquiryLoading,
      birthDate,
      ManagerName,
      Mobile,
      fileUpload,
      base64Loading
    } = this.state;
    return (
      <>
        <Helmet>
          <title>ثبت نام نماینده جدید | بیمه زندگی هامرز</title>
        </Helmet>
        <div className="agent-details">
        <div className="agent-details-section">

    <div className="d-flex justify-content-between flex-row-reverse">
    <div className="cursor-pointer" onClick={()=>logout()}>
                        <img alt="هامرز" src={Logout} className="ps-1 " />
                        خروج
                      </div>
                

    </div>
        {step === 1 && (
        
            <>
              <div className="row-container  w-100 ">
                <span className="agent-details-section-title d-flex align-items-baseline text-end w-100 ms-0">
                  <>استعلام پروانه</>
                  <hr className="hr-line" />
                </span>
              </div>
              <div className="form-section">
                <div className="row-container ">

                  <Input
                    max="5"
                    type="number"
                    error={
                      step1Errors?.filter(
                        (name: { path: string }) => name.path === "license_code"
                      )?.[0]?.errors?.[0]
                    }
                    isRequired
                    hideEndAdornment
                    iconBorder
                    myStyle="inquery-input w-100"
                    lable="کد پروانه"
                    placeholder=" کد پروانه خود را اینجا وارد کنید"
                    value={license_code}
                    onChange={(e: any) => this.setState({ license_code: e })}
                  />
                </div>
              </div>

              <Button
                myStyle="bg-light-blue select-btn mt-3"
                title=" استعلام"
                loading={inquiryLoading}
                onClick={() => this.increaseSteper()}
              />
            </>
           
        )}

        {step === 2 && (
         <>
              <div className="row-container  w-100  ">
                <span className="agent-details-section-title d-flex align-items-baseline text-end w-100 ms-0">
                  <>استعلام شرکت</>
                  <hr className="hr-line mt-3" />
                </span>
              </div>
              <div className="form-section">
                <div className="row-container">
                  <InfoCard
                    noMargin
                    myStyle="w-100"
                    value={`${this.state.BrkrType || ""}  ${
                      this.state.BrkrName || ""
                    }`}
                  />
                </div>
                <div className="row-container ">
                  {this.state.brag_type === 5 && (
                    <Input
                      error={
                        step1Errors?.filter(
                          (name: { path: string }) =>
                            name.path === "national_id"
                        )?.[0]?.errors?.[0]
                      }
                      isRequired
                      hideEndAdornment
                      iconBorder
                      myStyle="inquery-dropdown w-100"
                      lable="شناسه ملی"
                      placeholder=" شناسه ملی خود را اینجا وارد کنید"
                      value={national_id}
                      type="number"
                      max="11"
                      onChange={(e: any) => this.setState({ national_id: e })}
                    />
                  )}
                </div>
              </div>

              <Button
                myStyle="bg-light-blue select-btn mt-3"
                title=" مرحله بعدی"
                loading={inquiryLoading}
                onClick={() => this.increaseSteper()}
              />
           </>
        )}

        {step === 3 && (
          <>
              <div className="row-container  w-100 ">
                <span className="agent-details-section-title d-flex align-items-baseline text-end w-100 ms-0">
                  <>اطلاعات کارگزار</>

                  <hr className="hr-line" />
                </span>
              </div>
              <div className="form-section">
                <div className={`row-container `}>
                  <InfoCard
                    noMargin
                    myStyle="w-100"
                    value={`${this.state.BrkrType || ""}  ${
                      this.state.BrkrName || ""
                    }`}
                    lable="نام کارگزاری"
                  />
                </div>

                <div className="row-container ">
                  <InfoCard
                    noMargin
                    myStyle="w-30"
                    value={this.state.GrantDate}
                    lable="تاریخ شروع فعالیت"
                  />
                  <InfoCard
                    noMargin
                    myStyle="w-30"
                    value={this.state.ExpireDate}
                    lable="تاریخ پایان فعالیت"
                  />
                  <InfoCard
                    noMargin
                    myStyle="w-30"
                    value={this.state.Tel}
                    lable="  تلفن شرکت "
                  />
                </div>
                <div className="row-container ">
                  <InfoCard
                    noMargin
                    myStyle="w-100"
                    value={this.state.Address}
                    lable=" نشانی (محل سکونت) "
                  />
                </div>

                <div className="row-container  w-100 ">
                  <span className="agent-details-section-title d-flex align-items-baseline text-end w-100 ms-0">
                    <>اطلاعات نماینده</>
                    <hr className="hr-line " />
                  </span>
                </div>

                <div className="row-container ">
                  <InfoCard
                    noMargin
                    myStyle="w-48"
                    value={ManagerName}
                    lable="نام و نام خانوادگی"
                  />
                  <InfoCard
                    noMargin
                    myStyle="w-48"
                    value={Mobile}
                    lable=" شماره همراه "
                  />
                </div>
                <div className="row-container ">
                  <InfoCard
                    noMargin
                    myStyle="w-48"
                    value={moment(`${birthDate}`, "YYYY-M-D").format(
                      "jYYYY/jM/jD"
                    )}
                    lable="تاریخ تولد"
                  />
                  <InfoCard
                    noMargin
                    myStyle="w-48"
                    value={person}
                    lable="کدملی"
                  />
                </div>
              </div>

              <Button
                myStyle="bg-light-blue select-btn mt-3"
                title="ثبت درخواست"
                onClick={() => this.increaseSteper()}
              />
            </>
        )}

        {step === 4 && (
          <>


              <div className="row-container w-100">
                <span className="agent-edit-section-title d-flex align-items-baseline text-end w-100 ms-0">
                  <> مشخصات </>
                  <hr className="hr-line" />
                </span>
              </div>
              <div className="agent-details-info-container border">
                <ProfileInfo
                  myStyle="m-1"
                  title="نام کارگزاری"
                  value={this.state.BrkrName}
                />
                <ProfileInfo
                  myStyle="m-1"
                  title="تاریخ شروع"
                  value={this.state.GrantDate}
                />
                <ProfileInfo
                  myStyle="m-1"
                  title="تاریخ انقضاء"
                  value={this.state.ExpireDate}
                />
              </div>
              {step === 4 && 
                      <div className="agent-edit-download">
                      <Button loading={base64Loading} icon={Import} myStyle="download bg-light-blue next-btn loading-spinner-primary " title="قرارداد " onClick={()=>this.getBragAgreement()} />
                      
                      </div>
                    }
              <div className="agent-edit-upload">
                <div className="row-container w-100">
                  <span className="agent-edit-section-title d-flex align-items-baseline text-end w-100 ms-0">
                    <>  مدارک </>
                    <hr className="hr-line" />
                  </span>
                </div>
                <div className="uploader-container ">
                 
                  <div className="img-container">
                  <Button imageTag={ <img
                            src={Documentupload}
                            className=" ms-1"
                            alt="هامرز"
                          />}  myStyle="bg-light-blue table-btn upload-btn w-50 mt-0" title=" آپلود " onClick={() =>  this.setState({openModal:true})} />

                  </div>
                </div>
              </div>
              </>
        )}
                      </div>
                      <CustomModal myStyle="offers-upload-modal" openModal={this.state.openModal} onClose={() => this.closeModal()}>
          <>
            <div className="custom-modal-main-title mb-3 ">
              <h1 className="title">
                 مدارک              </h1>
              <Cancel myStyle="hide-desktop ps-2 " width="20" height="20" color="#000000" onClick={() => this.closeModal()} />
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.closeModal()} />
            </div>
            <div className="offers-upload">
              <div className="uploader-container ">
              <Dropdown
                    isRequired
                    objectList
                    items={this.state.dropdownOptionsUpload.brag_id || []}
                    iconBorder
                    displayEmpty
                    myStyle="inquery-dropdown w-100"
                    lable="  نوع سند دریافتی "
                    placeholder=" نوع سند دریافتی خود را اینجا وارد کنید "
                    value={this.state.upload_type}
                    onChange={(e: any) =>
                      this.setState({ upload_type: e.target.value })
                    }
                  />
                {this.state.file ?
                  <div className="file-container">

                    <span className="file-name">{fileUpload?.name}</span>
                    <Button myStyle="remove" title="حذف" onClick={() => this.setState({ fileUpload: "", file: "" })} />

                  </div>
                  :
                  <>
                    <span className="title">
                    لطفاً مدارک خود را از طریق بخش                       <span className="bold title">  بارگذاری ، </span>
                      <br />

                      آپلود کنید                              </span></>


                }
                <div className="img-container">


                  <div className="file-upload">
                    <div className="file-upload-btn">
                      <label className="file-upload-lable" htmlFor="file-input">

                        <img src={Documentupload}  className="cursor-pointer" alt="هامرز" />
                      </label>
                      <input
                        accept="image/*,.pdf,.excel"
                        type="file"
                        hidden
                        id="file-input"
                        onChange={(event) => this.uploadImage(event)}
                      />
                    </div>

                    <h5 className="file-upload-text"> بارگذاری </h5>
                  </div>
                </div>
                <div className="error-text w-100">
                  {uploadError.filter((name: { path: string; }) => name.path === `fileUpload`)?.[0]?.errors?.[0]}
                </div>
                
              </div>
              <div className="d-flex">
                <Button loading={inquiryLoading} myStyle="bg-light-blue table-btn upload-btn" title=" آپلود " onClick={() => this.uploadFile()} />
              </div>
            </div>
          </>
        </CustomModal>
                      </div>

      </>
    );
  }
}

const mapStateToProps = (dispatch: any) => ({
  dispatch,
  userData: dispatch.general.userData,
});

export default connect(mapStateToProps)(AgentSignUp);
